import { useEffect } from "react";
import Button from "components/Buttons";
import { motion, useAnimation } from "framer-motion";
import { scrollToPartnerRequestInfo } from "utils";

const HeroBanner = ({ data, loading }) => {
  const controlsScan = useAnimation();
  const controlsFit = useAnimation();
  const controlsPerform = useAnimation();

  const headerData = loading ? null : data?.listHeader?.[1];

  useEffect(() => {
    if (!headerData) {
      return;
    }
    const sequence = async () => {
      await controlsScan.start({
        opacity: 1,
        y: 0,
        transition: { duration: 1, delay: 0.2 },
      });
      await controlsFit.start({
        opacity: 1,
        y: 0,
        transition: { duration: 1 },
      });
      await controlsPerform.start({
        opacity: 1,
        y: 0,
        transition: { duration: 1 },
      });
    };
    sequence();
  }, [headerData, controlsScan, controlsFit, controlsPerform]);

  if (loading) {
    return null;
  }

  if (!headerData) {
    return null;
  }

  const isVideo = !!headerData?.video;

  return (
    <div className="!bg-[radial-gradient(286.94%_141.42%_at_100%_100%,_#FFF_0%,_#FAFAFA_100%)] md:pt-[54px] sm:pt-[25px] md:pb-[54px] sm:pb-[51px] pb-[17px] pt-[17px]">
      <section className="flex items-center justify-center relative text-white h-[606px] mx-auto w-[95%]">
        <div
          className="absolute top-0 left-0 w-full h-full rounded-[24px] bg-[#2b364b]"
          style={{
            backgroundImage:
              !isVideo && headerData?.image
                ? `url(${headerData.image})`
                : undefined,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          {isVideo && (
            <video
              preload="metadata"
              autoPlay
              loop
              muted
              playsInline
              className="absolute top-0 left-0 w-full h-full object-cover rounded-[24px]"
            >
              <source src={headerData?.video} type="video/mp4" />
            </video>
          )}
        </div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center lg:w-[814px] md:w-[700px] sm:w-[412px] w-[298px] ">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={controlsScan}
            className="uppercase font-barlowCondensed text-[32px] leading-auto md:text-[64px] md:leading-[96px] font-bold"
          >
            {headerData?.title}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={controlsFit}
            className="text-center md:text-[14px] md:leading-[24px] text-[12px] leading-auto font-montserrat"
          >
            {headerData?.description}
          </motion.p>
          {headerData?.btnLabel && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={controlsPerform}
              className="mt-6"
            >
              <Button
                type="button"
                className="!text-[14px] leading-[24px] text-[#2B364B] !bg-white font-medium font-montserrat rounded-[56px] !w-[128px] !h-[40px]"
                onClick={scrollToPartnerRequestInfo}
              >
                {headerData?.btnLabel}
              </Button>
            </motion.div>
          )}
        </div>
      </section>
    </div>
  );
};

export default HeroBanner;
